// =============================================================================
// app/src/lib/useFolhaPrevista.ts — a folha do mês nasce sem clique (094).
//
// Até 08/10/2026 a linha de salário do mês só existia depois que o dono abria
// o Painel e clicava "Lançar na folha" pessoa por pessoa. Até lá, Contas a
// pagar e o fluxo de caixa não viam salário nenhum daqui para frente.
//
// Este hook chama gerar_folha_prevista() UMA VEZ por mês por aparelho
// (staleTime infinito, chave com o mês) nas três telas que só o dono abre:
// Contas a pagar, Painel e Fluxo. Não vai no Layout de todo papel: a RPC nega
// gerente e vendedor, e seria um erro em cada tela deles.
//
// As consultas que leem a folha esperam este hook terminar (`pronto`) — mas
// carregam mesmo que a geração falhe: a tela continua mostrando o que o banco
// já tem, e a falha não esconde as contas.
// =============================================================================
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { gerarFolhaPrevista } from './consultas';
import { mesISO } from './formato';

/** As consultas que leem a folha e precisam ser refeitas quando ela muda. */
export const CHAVES_DA_FOLHA = [['folha-contas'], ['folha'], ['fluxo'], ['base-simulacao'], ['fluxo-simulado']] as const;

export function useFolhaPrevista(): { pronto: boolean; erro: unknown } {
  const cliente = useQueryClient();
  const prevista = useQuery({
    queryKey: ['folha-prevista', mesISO()],
    queryFn: async () => {
      const n = await gerarFolhaPrevista();
      if (n > 0) {
        for (const chave of CHAVES_DA_FOLHA) {
          void cliente.invalidateQueries({ queryKey: [...chave] });
        }
      }
      return n;
    },
    staleTime: Infinity,
    retry: false,
    // Voltar à aba não precisa gerar de novo: o mês não mudou.
    refetchOnWindowFocus: false,
  });
  return { pronto: !prevista.isPending, erro: prevista.error };
}
